export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatRequest {
  messages: ChatMessage[];
}

export interface ChatSseEvent {
  type: 'text' | 'tool_start' | 'tool_end' | 'done' | 'error';
  text?: string;
  toolName?: string;
  messages?: ChatMessage[];
  error?: string;
  inputTokens?: number;
  outputTokens?: number;
}

export class ChatApiWrapper {
  private baseUrl: string;
  private getApiKey: (key: string) => Promise<string>;

  constructor(baseUrl: string, getApiKey: (key: string) => Promise<string>) {
    this.baseUrl = baseUrl;
    this.getApiKey = getApiKey;
  }

  async *streamChat(
    request: ChatRequest,
    signal?: AbortSignal
  ): AsyncGenerator<ChatSseEvent> {
    const [authorization, userentity, referer] = await Promise.all([
      this.getApiKey('Authorization'),
      this.getApiKey('Userentity'),
      this.getApiKey('Referer'),
    ]);

    const response = await fetch(`${this.baseUrl}/api/v1/Chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authorization,
        Userentity: userentity,
        Referer: referer,
      },
      body: JSON.stringify(request),
      signal,
    });

    if (!response.ok) {
      yield { type: 'error', error: `Server error: ${response.status}` };
      return;
    }

    const reader = response.body!.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split('\n\n');
      buffer = parts.pop()!;

      for (const part of parts) {
        if (part.startsWith('data: ')) {
          try {
            yield JSON.parse(part.slice(6)) as ChatSseEvent;
          } catch {
            // malformed chunk — skip
          }
        }
      }
    }
  }
}

export function buildChatRequest(messages: ChatMessage[]): ChatRequest {
  return { messages };
}
